import "./Scholarships.module.css";
import Header from "@/reusable_sections/Header";
import ScholarshipOverview from "./sections/ScholarshipOverview";
import EligibilityApplicationProcess from "./sections/EligibilityApplicationProcess";
import CurrentScholarshipOpportunities from "./sections/CurrentScholarshipOpportunities";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ScholarshipsPage() {
  return <div>
      <Header />
      <ScholarshipOverview />
      <EligibilityApplicationProcess />
      <CurrentScholarshipOpportunities />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}